import MuiSnackbar from "@mui/material/Snackbar";

export default function Snackbar(props) {
  return <MuiSnackbar {...props} />;
}
